import gradient_dots_1 from "../../assets/Gradient_1_Dots.svg";
import gradient_dots_2 from "../../assets/Gradient_2_Dots.svg";

const dots = [gradient_dots_1, gradient_dots_2];

export default dots;
